import React, { PureComponent } from "react";
import { connect } from "react-redux";
import viewer from "react-mobile-image-viewer";
import "react-mobile-image-viewer/lib/index.css";
import "draft-js/dist/Draft.css";
import { imgProtocalTeck, cdnUrl } from "@/utils";
import { mapStateToProps } from "@/store";
import config from "@/config";
import SafeImage from "@/components/SafeImage";

const openImageViewer = [
    viewer,
    viewer?.default,
    viewer?.default?.default,
].find((candidate) => typeof candidate === "function");

const getImageSrc = (image = {}, thumb = "") =>
    image.src ? cdnUrl(image.src) : `${cdnUrl(image.key || "")}${thumb}`;

const getVideoSrc = (image = {}) =>
    getImageSrc({ src: image.videoSrc || image.videoKey });

class Isvideo extends PureComponent {
    // 预览视频
    handlePlayVideo(videoInfo) {
        const { dispatch } = this.props;
        const { videoSrc, videoPoster } = videoInfo;

        dispatch({
            type: "UPDATE_VIDEOSRC",
            src: videoSrc,
            poster: videoPoster,
        });
    }

    render() {
        const { videoInfo } = this.props;

        return (
            <button
                type="button"
                className="icon-play"
                aria-label="播放视频"
                onClick={(event) => {
                    event.stopPropagation();
                    this.handlePlayVideo(videoInfo);
                }}
            >
                <svg
                    className="icon-play__glyph"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                >
                    <path
                        d="M8.5 5.8a0.9 0.9 0 0 1 1.36-0.77l9.02 5.7a1.1 1.1 0 0 1 0 1.86l-9.02 5.7a0.9 0.9 0 0 1-1.36-0.77z"
                        fill="#fff"
                    />
                </svg>
            </button>
        );
    }
}

export default class ImgComputed extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            copyTimer: null,
        };
    }
    // 预览图片
    handlePreview(img, idx = 0) {
        const { item = {}, dispatch } = this.props;
        try {
            const imglist = item.images.map((item) => {
                return imgProtocalTeck(getImageSrc(item));
            });
            if (typeof openImageViewer !== "function") {
                throw new TypeError("图片预览组件加载失败");
            }
            this.v = openImageViewer({
                urls: imglist,
                index: idx,
            });
        } catch (err) {
            console.error(err);
            dispatch?.({
                type: "SHOW_TOAST",
                tstmsg: "图片预览暂时不可用，请稍后再试",
            });
        }
    }
    handleCopy(TEXT = "") {
        try {
            const { dispatch } = this.props;

            // 动态创建 input 元素
            let aux = document.createElement("input");
            // 获得需要复制的内容
            aux.setAttribute("value", TEXT);
            // 添加到 DOM 元素中
            document.body.appendChild(aux);
            // 执行选中
            aux.select();
            // 执行复制命令
            document.execCommand("copy");
            // 将 input 元素移除
            document.body.removeChild(aux);
            console.log("复制成功：" + TEXT);
            dispatch({
                type: "SHOW_TOAST",
                tstmsg: "复制成功~",
            });
        } catch (err) {
            console.error(err);
        }
    }
    onItemTouchStart(TEXT) {
        this.setState({
            copyTimer: setTimeout(() => {
                this.handleCopy(TEXT);
            }, 2000),
        });
    }
    onItemTouchEnd() {
        clearTimeout(this.state.copyTimer);
        this.setState({
            copyTimer: null,
        });
    }
    render() {
        const { item, dispatch } = this.props;

        if (!item.images) return null;

        let classComputed = "imglist";
        if (item.images && item.images.length === 1) {
            const IMGSRC = getImageSrc(item.images[0], config.thumb.w750);
            return (
                <div st="只有一张图片" className={classComputed}>
                    <span
                        className="img"
                        style={{
                            backgroundColor: item.images[0].bgColor
                                ? item.images[0].bgColor
                                : "#efefef",
                        }}
                        onTouchStart={this.onItemTouchStart.bind(this, IMGSRC)}
                        onTouchEnd={this.onItemTouchEnd.bind(this)}
                        onClick={() => this.handlePreview(IMGSRC)}
                    >
                        <SafeImage src={IMGSRC} alt="日记图片" loading="lazy" />
                        {item.images[0].type === "video" && (
                            <Isvideo
                                videoInfo={{
                                    videoSrc: getVideoSrc(item.images[0]),
                                    videoPoster: getImageSrc(
                                        item.images[0],
                                        config.thumb.w750,
                                    ),
                                }}
                                dispatch={dispatch}
                            />
                        )}
                    </span>
                </div>
            );
        } else if (item.images && item.images.length === 2) {
            classComputed += " imglistmulti img_50";
        } else if (item.images && item.images.length >= 2) {
            classComputed += " imglistmulti img_33";
        }
        classComputed += ` img-count-${Math.min(item.images.length, 9)}`;
        return (
            <div st="多张图片的样式" className={classComputed}>
                {item.images.map((img, idx) => {
                    return (
                        <span
                            className="img"
                            key={idx}
                            style={{
                                backgroundColor: img.bgColor
                                    ? img.bgColor
                                    : "#efefef",
                            }}
                            onTouchStart={this.onItemTouchStart.bind(
                                this,
                                img.src || cdnUrl(img.key),
                            )}
                            onTouchEnd={this.onItemTouchEnd.bind(this)}
                            onClick={() =>
                                this.handlePreview(
                                    getImageSrc(img, config.thumb.w750),
                                    idx,
                                )
                            }
                        >
                            <SafeImage
                                src={getImageSrc(img, config.thumb.w375)}
                                alt={`日记图片 ${idx + 1}`}
                                loading="lazy"
                            />
                            {img.type === "video" && (
                                <Isvideo
                                    videoInfo={{
                                        videoSrc: getVideoSrc(img),
                                        videoPoster: getImageSrc(
                                            img,
                                            config.thumb.w375,
                                        ),
                                    }}
                                    dispatch={dispatch}
                                />
                            )}
                        </span>
                    );
                })}
            </div>
        );
    }
}

ImgComputed = connect(mapStateToProps)(ImgComputed);
